import React from "react";
import { withNamespaces } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";

const radialBarOptions = {
    chart: {
        sparkline: {
            enabled: true,
        },
    },
    dataLabels: {
        enabled: true,
    },
    colors: ["#FF4949"],
    stroke: {
        lineCap: "round",
    },
    plotOptions: {
        radialBar: {
            hollow: {
                margin: 0,
                size: "70%",
            },
            track: {
                margin: 0,
            },
            dataLabels: {
                show: true,
                name: {
                    show: false,
                },
                value: {
                    show: true,
                    offsetY: 6,
                },
            },
        },
    },
};

const CreditCards = ({ t, title, totalCredits = 0, totalUsage = 0, remaining = 0 }) => {
    const usedPercent = totalCredits > 0 ? (totalUsage / totalCredits) * 100 : 0;
    const remainingPercent = totalCredits > 0 ? (remaining / totalCredits) * 100 : 0;

    return (
        <>
            {title ? (
                <Col sm="12">
                    <h5 className="mb-3">{t(title)}</h5>
                </Col>
            ) : null}

            <Col sm="12" md="4">
                <Card className="report-statistics-card">
                    <CardBody>
                        <Row>
                            <Col sm="6" md="8">
                                <div className="overflow-hidden">
                                    <p className="text-truncate">
                                        {t("Total {{creditsLabel}}", {
                                            creditsLabel: "Credits",
                                        })}
                                    </p>
                                    <h4 className="mb-0">{totalCredits}</h4>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>

            <Col sm="12" md="4">
                <Card className="report-statistics-card">
                    <CardBody>
                        <Row>
                            <Col sm="6" md="8">
                                <div className="overflow-hidden">
                                    <p className="text-truncate">
                                        {t("Used {{creditsLabel}}", {
                                            creditsLabel: "Credits",
                                        })}
                                    </p>
                                    <h4 className="mb-0">{totalUsage}</h4>
                                </div>
                            </Col>

                            <Col sm="6" md="4">
                                <ReactApexChart
                                    options={radialBarOptions}
                                    series={[usedPercent.toFixed(1)]}
                                    type="radialBar"
                                    height="60"
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>

            <Col sm="12" md="4">
                <Card className="report-statistics-card">
                    <CardBody>
                        <Row>
                            <Col sm="6" md="8">
                                <div className="overflow-hidden">
                                    <p className="text-truncate">
                                        {t("Remaining {{creditsLabel}}", {
                                            creditsLabel: "Credits",
                                        })}
                                    </p>
                                    <h4 className="mb-0">{remaining.toLocaleString()}</h4>
                                </div>
                            </Col>

                            <Col sm="6" md="4">
                                <ReactApexChart
                                    options={radialBarOptions}
                                    series={[remainingPercent.toFixed(1)]}
                                    type="radialBar"
                                    height="60"
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </>
    );
};

export default withNamespaces()(CreditCards);
